import { render, staticRenderFns } from "./DocumentDevCard.vue?vue&type=template&id=e1ff8622&scoped=true"
import script from "./DocumentDevCard.vue?vue&type=script&lang=js"
export * from "./DocumentDevCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ff8622",
  null
  
)

export default component.exports